import PersonIcon from "@atlaskit/icon/core/person";

import { wacToken } from "@/libraries/design/foundations";

export const CollaborationIcons = (
    <>
        <g transform="translate(86 270)">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="87"
                height="41"
                fill="none"
            >
                <rect
                    width="68.095"
                    height="22.095"
                    x=".063"
                    y="18.658"
                    fill={wacToken("color.extended.saffron400")}
                    rx="11.048"
                />
                <path
                    fill={wacToken("color.extended.saffron900")}
                    d="M10.72 30.64c0 .776.387 1.163 1.068 1.163.634 0 1.233-.387 1.34-1.268l.023-.188c.011-.094.011-.188.011-.294 0-.822-.434-1.186-1.033-1.186-.94 0-1.41.763-1.41 1.773Zm3.899 2.173c-.928 0-1.41-.481-1.515-1.174-.364.775-.963 1.174-1.715 1.174-1.116 0-1.762-.834-1.762-2.008 0-1.457.716-2.937 2.196-2.937.752 0 1.257.376 1.469 1.116l.105-.987h1.093l-.317 3.007c-.012.047-.012.106-.012.153 0 .364.2.646.599.646.587 0 .799-.681.799-1.574 0-1.82-.987-3.418-3.442-3.418-2.467 0-3.453 1.598-3.453 3.489 0 1.938.998 3.594 3.512 3.594.869 0 1.538-.188 2.055-.446l.036.986c-.564.34-1.222.47-2.15.47-2.89 0-4.522-1.868-4.522-4.604 0-2.631 1.632-4.5 4.522-4.5 2.878 0 4.499 1.869 4.499 4.417 0 1.387-.47 2.596-1.997 2.596ZM19.498 29.936c0-.337.079-.635.235-.893.149-.266.357-.474.623-.623.258-.156.556-.235.892-.235h3.383c.337 0 .635.079.893.235.266.15.474.357.623.623.156.258.235.556.235.893v.023c0 .337-.079.638-.235.904a1.696 1.696 0 0 1-.623.623 1.757 1.757 0 0 1-.893.223h-3.383c-.336 0-.634-.074-.892-.223a1.695 1.695 0 0 1-.623-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm3.361 0c0-.337.079-.635.235-.893.149-.266.357-.474.623-.623.258-.156.556-.235.892-.235h6.625c.337 0 .634.079.893.235.266.15.474.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.696 1.696 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223H24.61c-.336 0-.634-.074-.892-.223a1.696 1.696 0 0 1-.623-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm6.596 0c0-.337.078-.635.235-.893.149-.266.356-.474.622-.623.259-.156.556-.235.893-.235h6.625c.337 0 .634.079.893.235.266.15.473.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.696 1.696 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223h-6.625c-.337 0-.634-.074-.893-.223a1.695 1.695 0 0 1-.622-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm6.596 0c0-.337.078-.635.234-.893.15-.266.357-.474.623-.623.258-.156.556-.235.893-.235h6.624c.337 0 .635.079.893.235.267.15.474.357.623.623.156.258.235.556.235.893v.023c0 .337-.079.638-.235.904a1.695 1.695 0 0 1-.623.623 1.756 1.756 0 0 1-.892.223H37.8c-.337 0-.635-.074-.893-.223a1.695 1.695 0 0 1-.623-.623 1.75 1.75 0 0 1-.234-.904v-.023Zm6.595 0c0-.337.079-.635.235-.893.149-.266.356-.474.623-.623.258-.156.556-.235.892-.235h6.625c.337 0 .635.079.893.235.266.15.474.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.695 1.695 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223h-6.625c-.336 0-.634-.074-.892-.223a1.696 1.696 0 0 1-.623-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm6.596 0c0-.337.078-.635.235-.893.149-.266.356-.474.622-.623.259-.156.556-.235.893-.235h3.383c.337 0 .634.079.893.235.266.15.473.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.696 1.696 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223h-3.383c-.337 0-.634-.074-.893-.223a1.696 1.696 0 0 1-.622-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm3.36 0c0-.337.08-.635.236-.893.149-.266.356-.474.622-.623.259-.156.556-.235.893-.235h6.625c.337 0 .634.079.892.235.267.15.474.357.623.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.695 1.695 0 0 1-.623.623 1.757 1.757 0 0 1-.892.223h-6.625c-.337 0-.634-.074-.893-.223a1.696 1.696 0 0 1-.622-.623 1.75 1.75 0 0 1-.235-.904v-.023Z"
                />
                <path
                    fill={wacToken("color.extended.saffron400")}
                    d="M77.294 22.233 82.058 8.31l-13.9 4.786 6.09 3.045 3.046 6.09Z"
                />
            </svg>
        </g>
        <g transform="translate(340 205)">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="87"
                height="41"
                fill="none"
            >
                <rect
                    width="68.095"
                    height="22.095"
                    x=".063"
                    y="18.658"
                    fill={wacToken("color.primary.blue")}
                    rx="11.048"
                />
                <path
                    fill={wacToken("color.neutral.light0")}
                    d="M10.72 30.64c0 .776.387 1.163 1.068 1.163.634 0 1.233-.387 1.34-1.268l.023-.188c.011-.094.011-.188.011-.294 0-.822-.434-1.186-1.033-1.186-.94 0-1.41.763-1.41 1.773Zm3.899 2.173c-.928 0-1.41-.481-1.515-1.174-.364.775-.963 1.174-1.715 1.174-1.116 0-1.762-.834-1.762-2.008 0-1.457.716-2.937 2.196-2.937.752 0 1.257.376 1.469 1.116l.105-.987h1.093l-.317 3.007c-.012.047-.012.106-.012.153 0 .364.2.646.599.646.587 0 .799-.681.799-1.574 0-1.82-.987-3.418-3.442-3.418-2.467 0-3.453 1.598-3.453 3.489 0 1.938.998 3.594 3.512 3.594.869 0 1.538-.188 2.055-.446l.036.986c-.564.34-1.222.47-2.15.47-2.89 0-4.522-1.868-4.522-4.604 0-2.631 1.632-4.5 4.522-4.5 2.878 0 4.499 1.869 4.499 4.417 0 1.387-.47 2.596-1.997 2.596ZM19.498 29.936c0-.337.079-.635.235-.893.149-.266.357-.474.623-.623.258-.156.556-.235.892-.235h3.383c.337 0 .635.079.893.235.266.15.474.357.623.623.156.258.235.556.235.893v.023c0 .337-.079.638-.235.904a1.696 1.696 0 0 1-.623.623 1.757 1.757 0 0 1-.893.223h-3.383c-.336 0-.634-.074-.892-.223a1.695 1.695 0 0 1-.623-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm3.361 0c0-.337.079-.635.235-.893.149-.266.357-.474.623-.623.258-.156.556-.235.892-.235h6.625c.337 0 .634.079.893.235.266.15.474.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.696 1.696 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223H24.61c-.336 0-.634-.074-.892-.223a1.696 1.696 0 0 1-.623-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm6.596 0c0-.337.078-.635.235-.893.149-.266.356-.474.622-.623.259-.156.556-.235.893-.235h6.625c.337 0 .634.079.893.235.266.15.473.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.696 1.696 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223h-6.625c-.337 0-.634-.074-.893-.223a1.695 1.695 0 0 1-.622-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm6.596 0c0-.337.078-.635.234-.893.15-.266.357-.474.623-.623.258-.156.556-.235.893-.235h6.624c.337 0 .635.079.893.235.267.15.474.357.623.623.156.258.235.556.235.893v.023c0 .337-.079.638-.235.904a1.695 1.695 0 0 1-.623.623 1.756 1.756 0 0 1-.892.223H37.8c-.337 0-.635-.074-.893-.223a1.695 1.695 0 0 1-.623-.623 1.75 1.75 0 0 1-.234-.904v-.023Zm6.595 0c0-.337.079-.635.235-.893.149-.266.356-.474.623-.623.258-.156.556-.235.892-.235h6.625c.337 0 .635.079.893.235.266.15.474.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.695 1.695 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223h-6.625c-.336 0-.634-.074-.892-.223a1.696 1.696 0 0 1-.623-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm6.596 0c0-.337.078-.635.235-.893.149-.266.356-.474.622-.623.259-.156.556-.235.893-.235h3.383c.337 0 .634.079.893.235.266.15.473.357.622.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.696 1.696 0 0 1-.622.623 1.757 1.757 0 0 1-.893.223h-3.383c-.337 0-.634-.074-.893-.223a1.696 1.696 0 0 1-.622-.623 1.75 1.75 0 0 1-.235-.904v-.023Zm3.36 0c0-.337.08-.635.236-.893.149-.266.356-.474.622-.623.259-.156.556-.235.893-.235h6.625c.337 0 .634.079.892.235.267.15.474.357.623.623.157.258.235.556.235.893v.023c0 .337-.078.638-.235.904a1.695 1.695 0 0 1-.623.623 1.757 1.757 0 0 1-.892.223h-6.625c-.337 0-.634-.074-.893-.223a1.696 1.696 0 0 1-.622-.623 1.75 1.75 0 0 1-.235-.904v-.023Z"
                />
                <path
                    fill={wacToken("color.primary.blue")}
                    d="M77.294 22.233 82.058 8.31l-13.9 4.786 6.09 3.045 3.046 6.09Z"
                />
            </svg>
        </g>
        <g transform="translate(276 68)">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="78"
                height="32"
                fill="none"
            >
                <rect
                    width="27.76"
                    height="27.76"
                    x=".929"
                    y="2.12"
                    fill={wacToken("color.neutral.light0")}
                    rx="13.88"
                />
                <rect
                    width="27.76"
                    height="27.76"
                    x=".929"
                    y="2.12"
                    stroke={wacToken("color.primary.blue")}
                    strokeWidth="1.633"
                    rx="13.88"
                />
                <rect
                    width="27.76"
                    height="27.76"
                    x=".929"
                    y="2.12"
                    fill={wacToken("color.neutral.light0")}
                    rx="13.88"
                />
                <rect
                    width="27.76"
                    height="27.76"
                    x=".929"
                    y="2.12"
                    stroke={wacToken("color.primary.blue")}
                    strokeWidth="1.633"
                    rx="13.88"
                />
                <circle
                    cx="14.809"
                    cy="16"
                    r="13.064"
                    fill={wacToken("color.neutral.light300")}
                />
                <foreignObject x="0.81" y="2" width="28" height="28">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            color: wacToken("color.neutral.light800")
                        }}
                    >
                        <PersonIcon label="avatar" />
                    </div>
                </foreignObject>
                <rect
                    width="27.76"
                    height="27.76"
                    x="23.056"
                    y="2.12"
                    fill={wacToken("color.neutral.light0")}
                    rx="13.88"
                />
                <rect
                    width="27.76"
                    height="27.76"
                    x="23.056"
                    y="2.12"
                    stroke={wacToken("color.extended.saffron400")}
                    strokeWidth="1.633"
                    rx="13.88"
                />
                <rect
                    width="27.76"
                    height="27.76"
                    x="23.056"
                    y="2.12"
                    fill={wacToken("color.neutral.light0")}
                    rx="13.88"
                />
                <rect
                    width="27.76"
                    height="27.76"
                    x="23.056"
                    y="2.12"
                    stroke={wacToken("color.extended.saffron400")}
                    strokeWidth="1.633"
                    rx="13.88"
                />
                <circle
                    cx="36.936"
                    cy="16"
                    r="13.064"
                    fill={wacToken("color.neutral.light300")}
                />
                <foreignObject x="22.94" y="2" width="28" height="28">
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                            color: wacToken("color.neutral.light800")
                        }}
                    >
                        <PersonIcon label="second-avatar" />
                    </div>
                </foreignObject>
                <rect
                    width="30.422"
                    height="30.422"
                    x="46.789"
                    y=".789"
                    fill={wacToken("color.neutral.light300")}
                    rx="15.211"
                />
                <rect
                    width="30.422"
                    height="30.422"
                    x="46.789"
                    y=".789"
                    stroke={wacToken("color.neutral.light0")}
                    strokeWidth="1.578"
                    rx="15.211"
                />
                <path
                    fill={wacToken("color.primary.black")}
                    fillRule="evenodd"
                    stroke={wacToken("color.primary.black")}
                    strokeWidth=".915"
                    d="M61.5 16.5v4.167h1V16.5h4.166v-1H62.5v-4.167h-1V15.5h-4.167v1H61.5Z"
                    clipRule="evenodd"
                />
            </svg>
        </g>
    </>
);
